import getPASData from 'services/api/sdn/getPASData';
import store from 'store/Store';
import { SET_DYNAMIC_COMPONENTS_DATA } from 'constants/actionTypes/dynamicComponent';
import userUtils from 'utils/User';
import { UserInfoReady } from 'constants/events';
import Actions from 'Actions';
import Location from 'utils/Location';
import localeUtils from 'utils/LanguageLocale';
import Empty from 'constants/empty';

const { TYPES: ACTION_TYPES } = Actions;
const getText = localeUtils.getLocaleResourceFile('components/Bcc/BccRwdPersonalizedPromoList/PromoListFallback/locales', 'PromoListFallback');

class Feature {
    // eslint-disable-next-line class-methods-use-this
    execute(_components) {}
}

class PromotionListTargetedPAS extends Feature {
    // eslint-disable-next-line class-methods-use-this
    execute(components) {
        if (userUtils.isAnonymous()) {
            return;
        }

        const stateData = {};
        components.forEach(component => {
            // Use sys.id as key to avoid overwriting when multiple components have same sid
            const componentKey = component.sys?.id || component.sid;
            stateData[componentKey] = {
                featuresInProgress: ['PromotionList_Targeted_PAS'],
                data: {}
            };
        });

        store.dispatch({
            type: SET_DYNAMIC_COMPONENTS_DATA,
            payload: stateData
        });

        const contextIds = components.map(component => component.sys?.id).filter(Boolean);

        // Get dynamic endpoint URL from featuresDataCollection - required, no fallback
        const firstComponent = components[0];
        let apiEndpoint = null;

        if (firstComponent?.featuresDataCollection?.items) {
            const pasFeatureData = firstComponent.featuresDataCollection.items.find(item => item.key === 'PromotionListTargetedPAS');

            if (pasFeatureData?.value) {
                apiEndpoint = pasFeatureData.value;
            }
        }

        // Only call API if we have a valid endpoint
        if (!apiEndpoint) {
            return;
        }

        Sephora.Util.onLastLoadEvent(window, [UserInfoReady], () => {
            getPASData(contextIds, apiEndpoint)
                .then(response => {
                    const updatedStateData = {};
                    components.forEach(component => {
                        const componentSid = component.sid;
                        const componentKey = component.sys?.id || component.sid;

                        if (componentSid) {
                            let pasData = [];

                            if (response?.data?.aggregateContent?.data) {
                                const aggregateData = response.data.aggregateContent.data;
                                const matchingComponent = aggregateData.find(item => item.sid === componentSid);

                                if (matchingComponent && matchingComponent.items) {
                                    pasData = matchingComponent.items;
                                }
                            }

                            const dynamicComponent = {
                                ...component,
                                items: pasData || []
                            };

                            updatedStateData[componentKey] = {
                                featuresInProgress: [],
                                data: dynamicComponent
                            };
                        }
                    });

                    const aggregateContentData = response?.data?.aggregateContent?.data || Empty.Array;
                    const hasEmptyOffers = aggregateContentData.length === 0;

                    if (hasEmptyOffers && Location.isBasketPage()) {
                        // Hide content modal and then display an 'Try again' message when PAS does not return offers
                        store.dispatch({
                            type: ACTION_TYPES.SHOW_CONTENT_MODAL,
                            isOpen: false
                        });
                        store.dispatch(
                            Actions.showInfoModal({
                                isOpen: true,
                                title: getText('featuredOffersModalTitle'),
                                message: getText('noPromosTryAgainText'),
                                showCloseButton: true,
                                showFooter: false
                            })
                        );
                    } else {
                        store.dispatch({
                            type: SET_DYNAMIC_COMPONENTS_DATA,
                            payload: updatedStateData
                        });
                    }
                })
                .catch(error => {
                    Sephora.logger.error('Error fetching PAS data:', error);

                    const fallbackStateData = {};

                    components.forEach(component => {
                        const componentSid = component.sid;
                        const componentKey = component.sys?.id || component.sid;

                        if (componentSid) {
                            const dynamicComponent = {
                                ...component
                            };

                            fallbackStateData[componentKey] = {
                                featuresInProgress: [],
                                data: dynamicComponent
                            };
                        }
                    });

                    store.dispatch({
                        type: SET_DYNAMIC_COMPONENTS_DATA,
                        payload: fallbackStateData
                    });
                });
        });
    }
}

export default PromotionListTargetedPAS;
